import React from "react";
import { Outlet } from "react-router-dom";

const MovementServicesPage: React.FC = () => {
  return (
    <div data-testid="movement-services">
      <Outlet />
    </div>
  );
};

export default MovementServicesPage;
